var _circle, _circle2, _circle3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 18.5,
    r: 2.4,
    fill: "url(#paint0_linear_961_7393)",
    stroke: "url(#paint1_linear_961_7393)",
    strokeWidth: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 5,
    r: 4.9,
    fill: "url(#paint2_linear_961_7393)",
    stroke: "url(#paint3_linear_961_7393)",
    strokeWidth: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.9,
    fill: "url(#paint4_linear_961_7393)",
    stroke: "url(#paint5_linear_961_7393)",
    strokeWidth: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_961_7393",
    x1: 20.004,
    y1: 17.2923,
    x2: 14.3088,
    y2: 16.3372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7372B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17FE8",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_961_7393",
    x1: 19.9103,
    y1: 17.254,
    x2: 14.1907,
    y2: 16.3415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7372B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17FE8",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_961_7393",
    x1: 22.0081,
    y1: 2.58456,
    x2: 10.6177,
    y2: 0.674439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7372B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17FE8",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_961_7393",
    x1: 21.8205,
    y1: 2.50808,
    x2: 10.3814,
    y2: 0.682977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7372B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17FE8",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_961_7393",
    x1: 6.00485,
    y1: 1.55074,
    x2: -0.829395,
    y2: 0.404664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7372B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17FE8",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_961_7393",
    x1: 5.89232,
    y1: 1.50485,
    x2: -0.971135,
    y2: 0.409786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7372B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A17FE8",
    stopOpacity: 0.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/circles.2c764741b31df60c44d29e82234f2f4e.svg";
export { ForwardRef as ReactComponent };